import { useSelector } from 'react-redux';
import _ from 'lodash';
import InputForm from '../InputForm';
import { RootState } from '../../../../../../../state/store';
import formProfitTemplate from './formProfitTemplate.json';
import { getFormDataFromState, getForm, getRowTemplate } from '../../common/FormUtil';
import { FormGroup, FinanceFormType, FormGroupType, FormGroupI } from '../../../../../../../types/inputform.d';

export const generateFormProfitLoss = (
  group: FormGroupType,
  profitLossCells: any,
  dbJson: any,
  loanDetails: any
) => {
  const formCells = _.cloneDeep(profitLossCells);

  let allRows: any[] = [];
  let formDataCells: any;

  if (!_.isEmpty(formCells)) {
    formDataCells = getFormDataFromState(formCells, group);
  } else if (_.isEmpty(formCells)) {
    const formProfit = _.cloneDeep(formProfitTemplate) as any;

    // Total Rows //
    allRows = getRowTemplate('label', formProfit);
    formDataCells = getForm(
      formCells,
      FinanceFormType[FinanceFormType.FORMPROFITLOSS].toLowerCase(),
      group,
      allRows,
      dbJson,
      loanDetails
    );
  }

  return formDataCells;
};

export const FormProfitLoss = ({ group }: FormGroupI) => {
  const cells = useSelector(
    (state: RootState) =>
      state?.financeInputscreen?.cells![FinanceFormType[FinanceFormType.FORMPROFITLOSS].toLowerCase()]
  );

  if (!group || !cells) return <></>;

  const cellData: any = {};

  const actualsCells = Object.fromEntries(
    Object.entries(cells).filter(([, value]: any) => value?.group === FormGroup[FormGroup.ACTUALS].toLowerCase())
  );
  _.merge(cellData, actualsCells);

  if (group === FormGroup.PROJECTION) {
    const projectionCells = Object.fromEntries(
      Object.entries(cells).filter(
        ([, value]: any) => value?.group === FormGroup[FormGroup.PROJECTION].toLowerCase()
      )
    );
    _.merge(cellData, projectionCells);
  }

  return <InputForm cells={cellData} />;
};
